import React, { forwardRef } from "react";
import { Col, Row } from "react-bootstrap";

//Redux
import { useSelector } from "react-redux";
import {
  formatDate,
  getTimeFromStringInAmPm,
} from "../../../../common/Validations";

const PrintLoadingAdvice = forwardRef((props, ref) => {
  const appConfig = useSelector((state) => state?.app?.appConfig); // Application Details from Store

  const tableStyle = {
    border: "1px solid black",
    borderCollapse: "collapse",
    padding: "4px",
  };
  const printbody = {
    display: "flex",
    flexDirection: "column",
    margin: "10px",
  };
  // const thickUnderline = {
  //   display: "inlineBlock",
  //   width: "60%",
  //   borderBottom: "2px solid black",
  //   paddingBottom: "2px",
  // };
  const { data } = props;

  return (
    <div ref={ref} style={printbody} className="m-4">
      <div style={tableStyle}>
        <Row>
          <Col
            lg={12}
            className="fw-bold d-flex justify-content-end align-items-start pe-4"
          >
            <span className="m-0 me-2">Mob : </span>
            <div>
              <p className="m-0">9448380669</p>
              <p className="m-0">7411677666</p>
            </div>
          </Col>
          <Col
            lg={12}
            className="d-flex justify-content-center align-items-end"
          >
            <Col
              xs={{ offset: 3, span: 2 }}
              md={{ offset: 3, span: 2 }}
              lg={{ offset: 3, span: 2 }}
            >
              <img
                src={appConfig?.customerLogo1}
                alt="Bharthi_Cement_logo"
                className="introCustomerlogo"
              />
            </Col>
            <Col xs={9} md={9} lg={9}>
              <p className="fs-2 fw-bold m-0">
                {/* {appConfig?.customerName?.toUpperCase()} AGENCIES */}
                {data?.companyCodeDesc} 
              </p>
              {/* <span>FOR</span> {data?.companyCodeDesc} AGENCIES */}
            </Col>
          </Col>
          <Col
            lg={12}
            className="d-flex justify-content-center align-items-end"
          >
            <p className="fs-5 fw-bold m-0">
              #224, 17th 'C' Main, 4th Sector,
              <br />
              H.S.R Layout, Bangalore - 560 102.
            </p>
          </Col>
          <Col lg={12} className="d-flex justify-content-start fw-bold ms-4">
            Number: {data?.documentNumber}
          </Col>
          <Row>
            <Col
              xs={{ offset: 4, span: 4 }}
              md={{ offset: 4, span: 4 }}
              lg={{ offset: 4, span: 4 }}
              className="d-felx justify-content-center mt-2"
            >
              <p style={tableStyle} className="fs-5 text-center fw-bold">
                LOADING ADVICE
              </p>
            </Col>
          </Row>
          <Row className="px-4">
            <Col xs={1} md={1} lg={1} className="fw-bold mb-2">
              <p className="m-0 me-2">Sl.No</p>
            </Col>

            <Col xs={4} md={4} lg={4} className="fw-bold">
              <p className="m-0 me-2 text-center">Brand</p>
            </Col>

            <Col xs={3} md={3} lg={3} className="fw-bold ">
              <p className="m-0 me-2 text-center">Qty</p>
            </Col>
          </Row>
          {Array.isArray(data?.items) &&
            data?.items?.map((item, i) => (
              <Row key={i} className="px-4">
                <Col xs={1} md={1} lg={1} className="fw-bold mb-2">
                  <p style={tableStyle} className="m-0 me-2">
                    {i + 1}
                  </p>
                </Col>
                <Col xs={4} md={4} lg={4} className="fw-bold mb-2">
                  <p style={tableStyle} className="m-0 me-2">
                    {item?.materialDescription}
                  </p>
                </Col>

                <Col xs={3} md={3} lg={3} className="fw-bold ">
                  <p style={tableStyle} className="m-0 me-2">
                    {item?.orderQtyLoadConfirm}
                  </p>
                </Col>
                <Col xs={3} md={3} lg={3} className="fw-bold ">
                  <p style={tableStyle} className="m-0 me-2">
                    {item?.uOM === "BAGS" ? <>Bags</> : <>Nos.</>}
                  </p>
                </Col>
              </Row>
            ))}

          <Row className="px-4">
            <Col xs={4} md={4} lg={4} className="d-flex mt-4 fw-bold">
              <p className="me-2">Date:</p>
              <p>{formatDate(data?.items[0]?.loadingDate)}</p>
            </Col>
            <Col xs={4} md={4} lg={4} className="d-flex mt-4 fw-bold">
              <p className="me-2">Time:</p>
              <p>{getTimeFromStringInAmPm(data?.createdAt)}</p>
            </Col>
            <Col
              xs={4}
              md={4}
              lg={4}
              className="d-flex align-items-center mt-4 fw-bold"
            >
              <p className="me-2">Truck No :</p>
              <p className="fs-5 text-dark">
                {" "}
                {data?.items?.[0]?.loadingOtherTruckNo
                  ? data.items[0].loadingOtherTruckNo.toUpperCase()
                  : data?.items?.[0]?.loadingTruckNoDescription || ""}
              </p>
            </Col>
            <Col
              xs={4}
              md={4}
              lg={4}
              className="d-flex  mt-4 fw-bold text-nowrap"
            >
              <p>
                <span>Shipped Party : </span>
                {data?.items[0]?.shippedParty}
              </p>
            </Col>
            <Col
              lg={12}
              className="d-flex justify-content-end mt-4 fw-bold fw-bold"
            >
              <p>
                {" "}
                <span>FOR</span> {data?.companyCodeDesc}
              </p>
            </Col>
          </Row>
        </Row>
      </div>
    </div>
  );
});

export default PrintLoadingAdvice;
